module.exports = __webpack_public_path__ + "static/img/258_TO8_2321_og.7399b7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/258_TO8_2321_og.jpg
// module id = H76H
// module chunks = 0